<template>
  <LangRouterLink :to="{name: $route.name, hash: `#${HASHES.AVAILABLE_POSITIONS}`, query: customQuery}"
                  class="job-offer__filter">
    <span :class="['job-offer__filter-box', {'--active': active}]">
      <Icon id="checkmark"/>
    </span>
    <span>{{ content.name.replace('/', ' / ') }}</span>
  </LangRouterLink>
</template>

<script>
import {Icon, LangRouterLink} from '@/components/global'
import {HasContentMixin, UsesRoutesMixin} from '@/mixins'
import {QUERY_KEYS} from '@/helpers'

export default {
  name: 'JobOfferFilter',
  mixins: [HasContentMixin, UsesRoutesMixin],
  components: {Icon, LangRouterLink},
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['FIELD_TYPE', 'LOCATION', 'COMPANY'].includes(value)
    }
  },
  computed: {
    currentTypeValues() {
      let values = this.$route.query[this.queryKey]
      if (values === undefined) values = []
      values = values instanceof Array ? values : [values]

      return values
    },
    active() {
      return this.currentTypeValues.includes(this.content.id.toString())
    },
    customQuery() {
      const query = {...this.$route.query}

      let currentFilterValues = [...this.currentTypeValues]

      query[this.queryKey] = !this.active
          ? [...currentFilterValues, this.content.id.toString()]
          : currentFilterValues.filter(value => value !== this.content.id.toString())

      return query
    },
    queryKey() {
      return QUERY_KEYS[this.type]
    }
  }
}
</script>